import * as React from 'react'

const Chevron: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width={25} height={25} fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m8.418 13.21 5.293 5.294a1 1 0 1 0 1.414-1.414l-4.586-4.586 4.586-4.586a1 1 0 0 0-1.414-1.414l-5.293 5.293a1 1 0 0 0 0 1.414Z"
      fill="currentColor"
    />
  </svg>
)

export default Chevron
